import { Breadcrumb } from '../../types';

export const formsBreadcrumbs: Map<string, Breadcrumb> = new Map([
	[
		'formDraft',
		{
			name: 'formDraft',
			to: '/forms/draft',
			i18nKey: 'breadcrumb.formsDraft',
		},
	],
	[
		'formPending',
		{
			name: 'formPending',
			to: '/forms/pending',
			i18nKey: 'breadcrumb.formsPending',
		},
	],
	[
		'formPublic',
		{
			name: 'formPublic',
			to: '/forms/public',
			i18nKey: 'breadcrumb.formsPublic',
		},
	],
	[
		'formDetails',
		{
			name: 'formDetails',
			i18nKey: 'breadcrumb.formsDetails',
		},
	],
	[
		'formPreview',
		{
			name: 'formPreview',
			i18nKey: 'breadcrumb.formsPreview',
		},
	],
	[
		'formAll',
		{
			name: 'formAll',
			to: '/form-list',
			i18nKey: 'breadcrumb.formsAll',
		},
	],
	[
		'formEditCustomFields',
		{
			name: 'formEditCustomFields',
			i18nKey: 'breadcrumb.formsEditCustomFields',
		},
	],
]);
